/*
 * Yup for email address validation.
 * Is optional by default, can be changed.
 * Has default error message, can be changed.
 */
import * as yup from 'yup'
import { emailRegex } from '../strings/regex'

const maxLength = 250
const defaultMessage = 'Please provide a valid email address'
const defaultLengthMessage =
  'Email address cannot have more than 250 characters.'

export const emailYup = (
  required = false,
  errorMessage = defaultMessage,
  lengthMessage = defaultLengthMessage
) =>
  required
    ? yup
        .string()
        .matches(emailRegex, {
          message: errorMessage,
          excludeEmptyString: false
        })
        .required(errorMessage)
        .max(maxLength, lengthMessage)
    : yup
        .string()
        .matches(emailRegex, {
          message: errorMessage,
          excludeEmptyString: true
        })
        .max(maxLength, lengthMessage)
